{
  "contact-details": {
    "email": "Wāhitau īmēra",
    "mobilePhone": "Waea pūkoro",
    "nextLabel": "$t(common:next): <b>Tō rata GP (tākuta)</b>",
    "otherPhone": "Ētahi atu waea",
    "text": "Kua whakamahia ēnei kōrero hei whakapā atu ki a koe, engari ka taea te whakahou mēnā e tika ana.",
    "title": "Ō pārongo whakapā"
  },
  "doctor": {
    "gp": "Ingoa o te rata GP (tākuta)",
    "manually": "Kei te kore e puta te tākuta? <PrimaryText>Tāuritia ā-ringa...</PrimaryText>",
    "medicalCentre": "Pokapū Hauora",
    "nextLabel": "$t(common:next): <b>Tō whakapā ohotata</b>",
    "searchPlaceholder": "Kimihia tō rata GP, pokapū hauora rānei",
    "text": "Ko tēnei tō rata GP? Mēnā kāo, tēnā whakahoungia.",
    "title": "Tō rata GP (tākuta)"
  },
  "emergency": {
    "fullName": "Ingoa katoa",
    "mobileNumber": "Tau waea pūkoro",
    "nextLabel": "$t(common:next): <b>Inihua / ko wai te tangata e utu ana</b>",
    "relationship": "Hononga ki a koe",
    "select": {
      "child": "Tamariki",
      "friend": "Hoa",
      "other": "Ētahi atu",
      "parent": "Mātua",
      "spouse": "Hoa rangatira / hoa"
    },
    "text": "Me whakapā atu ki wai i te wā ohotata?",
    "title": "Tāu whakapā ohotata"
  },
  "home-address": {
    "building": "Papa, rūma, rānei o te hanga whare, o te wāhanga rānei",
    "city": "Tāone/Nūtara",
    "manually": "Kāore te wāhitau e puta ana? <PrimaryText>Tāuritia ā-ringa...</PrimaryText>",
    "nextLabel": "$t(common:next): <b>Ō pārongo whakapā</b>",
    "postcode": "Waehere poutāpeta",
    "searchPlaceholder": "Rapua te wāhitau i Aotearoa",
    "street": "Ingoa me te tau o te tiriti",
    "suburb": "Takiwā, RD rānei (Tuku Wāhi Taiwhenua)",
    "text": "Tēnā, whakaurua tō wāhitau kāinga:",
    "textSecondary": "Anei te wāhitau ka whakamahia e mātou:",
    "title": "Tō wāhitau kāinga"
  },
  "name-birthdate": {
    "birthDate": "Rā whānau",
    "dateFormat": "dd/mm/yyyy",
    "familyName": "Ingoa WHĀNAU:",
    "firstName": "Ingoa tuatahi",
    "nextLabel": "$t(common:next): <b>Tō NHI me tō nohoanga</b>",
    "preferredName": "Ingoa pai",
    "select": {
      "label": "Taitara",
      "mr": "Mr",
      "ms": "Ms",
      "mx": "Mx",
      "placeholder": "Tohua tō taitara"
    },
    "text": "Tēnā tirohia ēnei kōrero, ā, whakatikaina ngā mea hē, ngaro rānei:",
    "title": "Tō ingoa me tō rā whānau"
  },
  "nhi-residency": {
    "nextLabel": "$t(common:next): <b>Tō kāinga noho</b>",
    "nhiNumber": "Tau NHI (Tau Tauwhāinga Hauora ā-Motu)",
    "resident": "He kainoho koe nō Aotearoa?",
    "residentText": "Mēnā kāore koe he kainoho nō Aotearoa, tērā pea ka pāngia koe ki te utu mō ētahi ratonga, pērā i ngā whakamātautau taiwhanga.",
    "text": "Tēnā koa, tirohia āu kōrero, ā, whakatikahia ngā mea ngaro, hē rānei:",
    "title": "Tō tau NHI me tō tūnga noho"
  }
}
